import { Editor, Transforms } from 'slate';
import { getQueryOptions, WithQueryOptions } from '../utils/match';

export function splitNodes(editor: Editor, options?: WithQueryOptions<typeof Transforms.splitNodes, 1>) {
    return Transforms.splitNodes(editor, getQueryOptions(editor, options));
}
